module.exports = __webpack_public_path__ + "img/swh.bc82a91c.png";